/*
 * Copyright (c) 2026. Tooling Team
 */

import { baseApi } from "./baseApi";
import { BASE_URL } from "../../utils/constants";

export const clientApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientList: builder.query({
      query: () => ({
        url: `${BASE_URL}v1/clients/list`,
        method: "GET",
      }),
    }),
    createClient: builder.mutation({
      query: (payload) => ({
        url: `${BASE_URL}v1/clients/create`,
        method: "POST",
        body: payload,
      }),
    }),
    updateClient: builder.mutation({
      query: ({ clientId, payload }) => ({
        url: `${BASE_URL}v1/clients/update/${clientId}`,
        method: "PUT",
        body: payload,
      }),
    }),
    retireClient: builder.mutation({
      query: ({ clientId, payload }) => ({
        url: `${BASE_URL}v1/clients/retire/${clientId}`,
        method: "PATCH",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetClientListQuery,
  /* Commenting out as not used currently
  useLazyGetClientsQuery,
  useGetClientByIdQuery,
  useLazyGetClientByIdQuery,
  useDeleteClientMutation,
   */
  useCreateClientMutation,
  useRetireClientMutation,
  useUpdateClientMutation,
} = clientApi;
